import { colors } from 'theme'
import css from 'styled-jsx/css'

export default css`
  .box{
    background: ${colors.white};
    border: solid 1px ${colors.border};
  }
  .box-header{
    padding: 0 1.5rem;
    border-bottom: solid 1px ${colors.border};
    height: 69px;
    display: flex;
    flex: 1;
    align-items: center;
  }
  .box-header h2{
    font-size: .97rem;
    font-weight: 900;
    color:${colors.secondary}
  }
`
